module.exports = __webpack_public_path__ + "img/france-bleu-logo-vector.37c8f093.svg";